import React from 'react';
import { connect } from 'react-redux';
import { useTable } from 'react-table';
import { getEditRecord, toDateString } from './util';
import { updateAdhocInfo, getAdhocRequest } from './thunks';
import _ from 'lodash';
import moment from 'moment';
import BTable from 'react-bootstrap/Table';
import 'bootstrap/dist/css/bootstrap.min.css';
import './AdhocTable.css';

const AdhocTable = ({ userInfo, adhocInfo, startUpdateAdhocInfo, startGetAdhocRequest }) => {
  
  const truncateString = (value) => {
    let MAX_STRING_LENGTH = 15;
    if (value && value.length > MAX_STRING_LENGTH) {
      value = value.substr(0, MAX_STRING_LENGTH) + ' ...';
    }
    return value;
  }
  
  const onReqIdClick = event => {
    // console.log('>>> onReqIdClick', event.target.getAttribute('data-id'));
    let requestId = event.target.getAttribute('data-id');
    startGetAdhocRequest({ id:requestId });
    startUpdateAdhocInfo({ showCreateDialog:true, mode:'edit' });
    event.preventDefault();
    return false;
  };
  
  // ? authorized by, programmer received date, turnaround days, programming days
  const columns = React.useMemo(() => [
    {
      Header: 'Request Id',
      accessor: 'request_id',
      Cell: e => <a href={e.value} data-id={e.value} onClick={onReqIdClick} > {e.value} </a>,
    },
    {
      Header: 'Program',
      accessor: 'program',
    },
    {
      Header: 'Study',
      accessor: 'study',
    },
    {
      Header: 'Milestone',
      accessor: 'milestone',
    },
    // {
    //   Header: 'Description',
    //   accessor: 'description',
    //   Cell: e => <span> {truncateString(e.value)} </span>,
    // },
    {
      Header: 'Title',
      accessor: 'request_title',
      Cell: e => <span> {truncateString(e.value)} </span>,
    },
    {
      Header: 'Related Task',
      accessor: 'related_task_name',
    },
    {
      Header: 'Request By',
      accessor: 'requester_name',
    },
    {
      Header: 'Requester Organization',
      accessor: 'requester_org',
    },
    {
      Header: 'Due Date',
      accessor: 'due_date',
      Cell: e => <span> {toDateString(e.value)} </span>,
    },
    {
      Header: 'Urgency Level',
      accessor: 'urgency_level',
    },
    {
      Header: 'Request Status',
      accessor: 'request_status',
    },
    {
      Header: 'Response Lead',
      accessor: 'response_lead',
    },
    {
      Header: 'Programmers',
      accessor: 'programmer',
    },
    {
      Header: 'Request Date',
      accessor: 'request_date',
      Cell: e => <span> {toDateString(e.value)} </span>,
    },
    {
      Header: 'Delivery Date',
      accessor: 'delivery_date',
      Cell: e => <span> {toDateString(e.value)} </span>,
    },
    {
      Header: 'Turnaround Days',
      accessor: 'turnaround_days',
    },
    {
      Header: 'Programmer Received Date',
      accessor: 'programmer_request_date',
      Cell: e => <span> {toDateString(e.value)} </span>,
    },
    {
      Header: 'Programmer Completed Date',
      accessor: 'programmer_complete_date',
      Cell: e => <span> {toDateString(e.value)} </span>,
    },
    {
      Header: 'Programming Days',
      accessor: 'programming_days',
    },
    {
      Header: '# Datesets',
      accessor: 'number_datasets',
    },
    {
      Header: '# Tables',
      accessor: 'number_tables',
    },
    {
      Header: '# Figures',
      accessor: 'number_figures',
    },
    {
      Header: '# Listing',
      accessor: 'number_listings',
    },
  ], []);
  
  const getColumnProps= column => ({
    // onClick: () => alert('Column!'),
  })
  
  const getCellProps= cellInfo => ({
    // style: {
    //   backgroundColor: `hsl(${120 * ((120 - cellInfo.value) / 120) * -1 +
    //     120}, 100%, 67%)`,
    // },
  })
  
  let data = adhocInfo.records;
  let {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data });
  
  const onNewAdhocReport = (event) => {
    console.log('>>> onNewAdhocReport');
    // clear editRecord
    let newRecord = getEditRecord({}, adhocInfo.editRecord);
    for (var property in newRecord) {
      newRecord[property] = '';
    }
    newRecord['program'] = adhocInfo.searchParameter.program;
    newRecord['study'] = adhocInfo.searchParameter.study;
    newRecord['milestone'] = adhocInfo.searchParameter.milestone;
    newRecord['request_date'] = moment().toDate();
    startUpdateAdhocInfo({ showCreateDialog:true, mode:'create', editRecord:newRecord });
    event.preventDefault();
    return false;
  };
  
  const content = (
    <div className="AdhocTableContainer">
      <div className="col-auto">
        <button type="submit" className="btn btn-adhoc btn-light btn-new-adhoc-report" 
          onClick={onNewAdhocReport}>New Adhoc Request</button>
      </div>
      <BTable className="table-adhoc" bordered striped  hover size="sm" {...getTableProps()}>
         <thead>
           {headerGroups.map(headerGroup => (
             <tr {...headerGroup.getHeaderGroupProps()}>
               {headerGroup.headers.map(column => (
                 <th
                   {...column.getHeaderProps()}
                   style={{}} >
                   {column.render('Header')}
                 </th>
               ))}
             </tr>
           ))}
         </thead>
         <tbody {...getTableBodyProps()}>
           {rows.map(row => {
             prepareRow(row)
             return (
               <tr {...row.getRowProps()}>
                 {row.cells.map(cell => {
                   return (
                     <td
                       {...cell.getCellProps([
                         {
                           className: cell.column.className,
                           style: cell.column.style,
                         },
                         getColumnProps(cell.column),
                         getCellProps(cell),
                       ])}
                       style={{
                         // padding: '10px',
                         // border: 'solid 1px gray',
                         // background: 'papayawhip',
                       }} >
                       {cell.render('Cell')}
                     </td>
                   )
                 })}
               </tr>
             )
           })}
         </tbody>
       </BTable>
    </div>
  );
  return content;
};

const mapState = state => ({
  userInfo: state.userInfo,
  adhocInfo: state.adhocInfo,
})

const mapDispatch = dispatch => ({
  startUpdateAdhocInfo: (data) => dispatch(updateAdhocInfo(data)),
  startGetAdhocRequest: (data) => dispatch(getAdhocRequest(data)),
})

export default connect(mapState, mapDispatch)(AdhocTable);
